import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
import { Rosemary } from './botanical/Rosemary';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/9g9ftWJsteQG1r7DZ97kAX/portada_2_hogar_natural.png';
export function NewProductReveal() {
  return <Section className="bg-forest-mist py-24 relative overflow-hidden" data-id="element-244">
      <Rosemary className="absolute -bottom-10 -left-10 w-64 h-64 text-moss opacity-10 blur-[1px] rotate-45 pointer-events-none" aria-hidden="true" data-id="element-245" />

      <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-246">
        {/* Image */}
        <div className="relative flex justify-center order-2 lg:order-1" data-id="element-247">
          <div aria-hidden="true" className="absolute inset-0 bg-honey/15 blur-3xl rounded-full scale-90" data-id="element-248" />
          <img src={PRODUCT_IMAGE} alt="Hogar Natural en Casa — sistema digital completo" className="relative w-full max-w-[460px] h-auto rounded-2xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.35)] border border-white/40" data-id="element-249" />
        </div>

        {/* Content */}
        <div className="text-center lg:text-left order-1 lg:order-2" data-id="element-250">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest-deep mb-6" data-id="element-251">
            Hogar Natural en Casa
          </h2>

          <p className="text-xl md:text-2xl text-forest-deep/90 mb-8 font-medium text-balance" data-id="element-252">
            El sistema que te enseña exactamente qué hacer, con qué y cómo, la
            próxima vez que aparezca un malestar en tu hogar.
          </p>

          <div className="text-lg text-forest/80 leading-relaxed mb-10" data-id="element-253">
            <ul className="space-y-3" data-id="element-254">
              <li className="flex items-center gap-2" data-id="element-255">
                <span className="text-moss" data-id="element-256">✔</span> Qué hacer frente a una tos
                nocturna.
              </li>
              <li className="flex items-center gap-2" data-id="element-257">
                <span className="text-moss" data-id="element-258">✔</span> Qué hacer cuando aparece
                acidez.
              </li>
              <li className="flex items-center gap-2" data-id="element-259">
                <span className="text-moss" data-id="element-260">✔</span> Qué hacer ante gases o
                panza hinchada.
              </li>
              <li className="flex items-center gap-2" data-id="element-261">
                <span className="text-moss" data-id="element-262">✔</span> Qué hacer para relajarte
                antes de dormir.
              </li>
              <li className="flex items-center gap-2" data-id="element-263">
                <span className="text-moss" data-id="element-264">✔</span> Qué hacer ante dolores
                cotidianos.
              </li>
            </ul>
          </div>

          <Button variant="primary" size="lg" href={CHECKOUT_URLS.superPack} className="bg-forest-deep hover:bg-forest text-white w-full sm:w-auto px-8 py-4" data-id="element-265">
            👉 QUIERO ACCESO INMEDIATO
          </Button>
        </div>
      </div>
    </Section>;
}